module.exports = __webpack_public_path__ + "img/lois.f085308b.png";